import { React, useState, useEffect } from "react";
import { Button, Icon, Modal, Grid } from "semantic-ui-react";
import { isEmpty, map } from "lodash";
import PropTypes from "prop-types";

// Redux
import { connect } from "react-redux";

// Components
import dataHandler from "@Utils/dataHandler";
import IkTable from "@Components/IkTable";

// Styles
import styles from "./styles.module.css";

const ContactsFilter = ({
	onClose,
	dispatch,
	selectedContact,
	omitListId,
	multiple,
	field,
	query,
	url,
	urlParams,
	tableColumns,
	selectTitle = "Seleccionar",
	isWhatsapp = false,
	onAddButtonClick = () => {},
	cardLine1 = [],
	cardLine2 = [],
	mobileCardView = false,
}) => {
	// hooks

	// contact

	const [filteredCount, setFilteredCount] = useState(null);
	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredPrintData, setFilteredPrintData] = useState([]);
	const [contactData, setContactData] = useState({});
	// hooks
	const [checkAllData, setCheckAllData] = useState([]);

	let paramFromInput = {};
	if (field) {
		paramFromInput = {
			...paramFromInput,
			[field]: query,
			fields: map(tableColumns, (item) => {
				return item.key;
			}),
		};
	}
	const defaultParams = multiple
		? {
				page: 1,
				rows: 15,
				[`id[]!`]: map(omitListId, (item) => {
					return item.id;
				}),
				orderKey: "id",
				orderDir: "desc",
				...urlParams,
				...paramFromInput,
		  }
		: { page: 1, rows: 15, orderKey: "id", orderDir: "desc", ...urlParams, ...paramFromInput };

	useEffect(() => {
		(async () => {
			const clientsPromise = dataHandler({
				dispatch,
				url,
				params: { ...defaultParams },
			});
			const [clientsResponse] = await Promise.all([clientsPromise]);
			setFilteredItems(clientsResponse.items);
			setFilteredCount(clientsResponse.count);
		})();
	}, []);

	const handleButtom = (name, item) => {
		switch (name) {
			case "onClick":
				if (!multiple) {
					setContactData(item);
				}
				break;

			case "Watch":
				save();
				break;
			default:
				break;
		}
	};

	const handlerMultiple = (selectedItems) => {
		setContactData(selectedItems);
	};

	// Table handlers
	const handlerData = async (params, printable, findAll) => {
		let newParams = { ...params, ...urlParams };
		if (!isEmpty(omitListId)) {
			newParams = {
				...newParams,
				[`id[]!`]: map(omitListId, (item) => {
					return item.id;
				}),
			};
		}

		const data = await dataHandler({ dispatch, url, params: newParams });
		if (data.items.length === 1) {
			if (!multiple) {
				selectedContact(data.items[0]);
			} else {
				selectedContact(data.items);
			}
			onClose();
		}

		if (printable) {
			setFilteredPrintData(data.items);
		} else {
			setFilteredItems(data.items);
			setFilteredCount(data.count);
		}

		if (findAll) {
			setCheckAllData(data.items);
		} else {
			setFilteredItems(data.items);
			setFilteredCount(data.count);
		}
	};

	// saveHandlers
	const save = (item = {}) => {
		let itemToSave = contactData;
		if (!isEmpty(item)) itemToSave = item;
		selectedContact(itemToSave);
		onClose();
	};

	return (
		<div>
			<Modal
				open
				closeIcon
				className={styles.modalFirst}
				onClose={() => {
					onClose();
				}}>
				<Modal.Header className={styles.modalHeader}>
					<Icon name="filter" />
					{selectTitle}
				</Modal.Header>
				<Modal.Content className={styles.modalContent} scrolling>
					<Grid className={styles.container} columns={1}>
						<Grid.Column className={styles.columns}>
							<IkTable
								topPlaceClassName={styles.topPlaceWrap}
								addButton={{ label: "Agregar" }}
								showAddButton={isWhatsapp}
								onAddButtonClick={onAddButtonClick}
								data={filteredItems}
								columns={[
									{
										hidden: !multiple,
										multiple,
										key: "id",
										dataPosition: "center",
										width: 1,
									},
									...tableColumns,
								]}
								searcher={{
									searchable: true,
									searchPosition: "flex-start",
									searchDisabled: false,
									filterButton: false,
									searchString: query,
									field,
									width: "40rem",
								}}
								totalRows={filteredCount}
								filteredPrintData={filteredPrintData}
								defaultParams={defaultParams}
								handlerMultiple={handlerMultiple}
								checkAllData={checkAllData}
								dataHandler={handlerData}
								handlerTable={handleButtom}
								mobileCardView={mobileCardView}
								cardLine1={cardLine1}
								cardLine2={cardLine2}

								/* 		addButton={{ label: "Agregar" }} */
							/>
						</Grid.Column>
					</Grid>
				</Modal.Content>
				<Modal.Actions className={styles.modalFooter}>
					<Button
						className={styles.negativeButton}
						onClick={() => {
							onClose();
						}}>
						Atrás
					</Button>

					<Button
						className={styles.positiveButton}
						disabled={isEmpty(contactData)}
						onClick={() => {
							return save();
						}}>
						Agregar
					</Button>
				</Modal.Actions>
			</Modal>
		</div>
	);
};

function mapStateToProps({ user }) {
	return {
		user,
	};
}

ContactsFilter.propTypes = {
	onClose: PropTypes.func,
	omitListId: PropTypes.array,
	selectedContact: PropTypes.func,
	multiple: PropTypes.bool,
	field: PropTypes.string,
	query: PropTypes.string,
	dispatch: PropTypes.func,
	url: PropTypes.string,
	urlParams: PropTypes.object,
	tableColumns: PropTypes.array,
	selectTitle: PropTypes.string,
	isWhatsapp: PropTypes.bool,
	onAddButtonClick: PropTypes.func,
	cardLine1: PropTypes.array,
	cardLine2: PropTypes.array,
	mobileCardView: PropTypes.bool,
};

export default connect(mapStateToProps)(ContactsFilter);
